/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyPermissionsVo from './CompanyPermissionsVo';
import CompanyRoleVo from './CompanyRoleVo';




  /**
   * The CompanyLoginSuccessVo model module.
   * @module account/model/CompanyLoginSuccessVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CompanyLoginSuccessVo</code>.
   * @alias module:account/model/CompanyLoginSuccessVo
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>CompanyLoginSuccessVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account/model/CompanyLoginSuccessVo} obj Optional instance to populate.
   * @return {module:account/model/CompanyLoginSuccessVo} The populated <code>CompanyLoginSuccessVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'avatarUrl')) {
        obj['avatarUrl'] = ApiClient.convertToType(data['avatarUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gender')) {
        obj['gender'] = ApiClient.convertToType(data['gender'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'token')) {
        obj['token'] = ApiClient.convertToType(data['token'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'company')) {
        obj['company'] = CompanyPermissionsVo.constructFromObject(data['company']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyList')) {
        obj['companyList'] = ApiClient.convertToType(data['companyList'], [CompanyRoleVo]);
      }
    }
    return obj;
  }

  /**
   * 用户id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 0学生1老师
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 身份证号，若返回为空，则跳转到完善个人信息页面
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 头像
   * @member {String} avatarUrl
   */
  exports.prototype['avatarUrl'] = undefined;
  /**
   * 性别 0：未知、1：男、2：女
   * @member {Integer} gender
   */
  exports.prototype['gender'] = undefined;
  /**
   * jwt token
   * @member {String} token
   */
  exports.prototype['token'] = undefined;
  /**
   * 当前登录公司组织信息
   * @member {module:account/model/CompanyPermissionsVo} company
   */
  exports.prototype['company'] = undefined;
  /**
   * 用户所在全部公司列表
   * @member {Array.<module:account/model/CompanyRoleVo>} companyList
   */
  exports.prototype['companyList'] = undefined;



  export default exports;
;


